import { getPlanRegion } from './getPlanRegion';

export const SOLO_CONNECT_REGION_CAPABILITY = {
  USA: 'USA',
  ROW: 'ROW',
};

const KNOWN_KIT_CONFIG_BY_PART_NUMBER = {
  'LU-SOLO-LRTC-KIT-02': {
    modem: '2',
    regionCapability: SOLO_CONNECT_REGION_CAPABILITY.USA,
  },
  'LU-SIMPACK-IOT-2': {
    modem: '2',
    regionCapability: SOLO_CONNECT_REGION_CAPABILITY.USA,
  },
  'LU-SOLO-LRTC-KIT-02-EA': {
    modem: '2',
    regionCapability: SOLO_CONNECT_REGION_CAPABILITY.ROW,
  },
  'LU-SOLO-LRTC-KIT-03': {
    modem: '3',
    regionCapability: SOLO_CONNECT_REGION_CAPABILITY.USA,
  },
  'LU-SIMPACK-IOT-3': {
    modem: '3',
    regionCapability: SOLO_CONNECT_REGION_CAPABILITY.USA,
  },
  'LU-SOLO-KIT-04-BELT': {
    modem: '4',
    regionCapability: SOLO_CONNECT_REGION_CAPABILITY.USA,
  },
  'LU-SOLO-LRTC-KIT-04-EA': {
    modem: '4',
    regionCapability: SOLO_CONNECT_REGION_CAPABILITY.ROW,
  },
  'LU-SOLO-KIT-04-EA-BELT': {
    modem: '4',
    regionCapability: SOLO_CONNECT_REGION_CAPABILITY.ROW,
  },
};

function normalizePartNumber(partNumber) {
  return typeof partNumber === 'string'
    ? partNumber.trim().toUpperCase()
    : '';
}

export function getSoloConnectKitConfig(partNumber) {
  return KNOWN_KIT_CONFIG_BY_PART_NUMBER[normalizePartNumber(partNumber)] || null;
}

export function getSoloConnectModemCount(partNumber) {
  const kitConfig = getSoloConnectKitConfig(partNumber);
  if (kitConfig?.modem) return kitConfig.modem;

  const normalizedPartNumber = normalizePartNumber(partNumber);
  const modemMatch = normalizedPartNumber.match(
    /(?:KIT-|IOT-|LRTC-[MY]-|MONTHLY-|YEARLY-)(0?[234])(?:\b|-)/,
  );

  if (!modemMatch) return '';

  return String(Number(modemMatch[1]));
}

export function getSoloConnectEligiblePlans(plans, modem, regionCapability) {
  if (!Array.isArray(plans) || !modem) return [];

  return plans.filter((plan) => {
    if (plan?.metadata?.service_type !== 'soloconnect') return false;
    if (plan?.metadata?.modem !== String(modem)) return false;

    const planIsRegional = plan.id?.split('-')[2] === 'ROW';

    if (regionCapability === SOLO_CONNECT_REGION_CAPABILITY.ROW) {
      return planIsRegional;
    }

    if (regionCapability === SOLO_CONNECT_REGION_CAPABILITY.USA) {
      return !planIsRegional;
    }

    return true;
  });
}

export function findSoloConnectReplacementPlan({
  plans,
  currentPlan,
  currentPlanId,
  newModem,
}) {
  if (!Array.isArray(plans) || !newModem) return null;

  const planId = currentPlanId || currentPlan?.id;
  const currentRegion = getPlanRegion(planId)?.value || '';
  const currentInterval = currentPlan?.interval || '';
  const currentIsRegional = Boolean(currentRegion);

  return (
    plans.find((plan) => {
      if (plan?.metadata?.service_type !== 'soloconnect') return false;
      if (plan?.metadata?.modem !== String(newModem)) return false;
      if (currentInterval && plan.interval !== currentInterval) return false;

      const planRegion = getPlanRegion(plan.id)?.value || '';

      if (currentIsRegional) {
        return planRegion === currentRegion;
      }

      return !planRegion;
    }) || null
  );
}
